import styled from 'styled-components';
import { Button } from 'components';
import { colors } from 'styles/colors';

export const UpgradeModuleContainer = styled.div`
  display: flex;
  gap: 16px;
  height: 33px;

  & > div {
    display: flex;
    gap: 10px;
    align-items: center;

    & > svg {
      flex-shrink: 0;
    }

    & > span {
      font-weight: 400;
      font-size: 16px;
      line-height: 180%;
      color: ${colors.text['main-900']};
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    & > div > span {
      font-size: 12px;
    }
  }
`;

export const UpgradeButton = styled(Button)<{ onlyButton?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ onlyButton }) => (onlyButton ? `
    width: 94px;
    gap: 6px;
  ` : `
    width: 140px;
    gap: 16px;
  `)};
`;
